import { render } from "./announcementPage.vue?vue&type=template&id=a4248caa&scoped=true&ts=true"
import script from "./announcementPage.vue?vue&type=script&lang=ts"
export * from "./announcementPage.vue?vue&type=script&lang=ts"

import "./announcementPage.vue?vue&type=style&index=0&id=a4248caa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4248caa"]])

export default __exports__